module.exports = __webpack_public_path__ + "2499a349a51df9456243255bfab4ff35.gif";